import { makeStyles } from '@eagleview/ev-comp-library';

/**
 * Styling associated Success component
 */
export default makeStyles({
  stepBox: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'start',
    border: '1px solid #C8CDD7',
    borderRadius: '4px',
    padding: '48px',
    gap: '24px',
    width: '100%',
    '@media (max-width: 675px)': {
      padding: '24px',
    },
  },
  stepHeader: {
    color: '#1B202C',
    fontFamily: 'Noto Sans',
    fontSize: '32px',
    fontStyle: 'normal',
    fontWeight: 300,
    lineHeight: '48px',
  },
  descHeader: {
    color: '#1B202C',
    fontFamily: 'Noto Sans',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '36px',
  },
  stepDetails: {
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '25px',
  },
  partnerUrlButtonContainer: {
    padding: '0px 24px 0px 56px',
    '@media (max-width: 675px)': {
      padding: '0px',
    },
    width: '100%',
  },
  partnerUrlButton: {
    color: '#FFFFFF',
    backgroundColor: '#007CAD',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '21px',
    textTransform: 'none',
    padding: '10px 16px 10px 16px',
    borderRadius: '4px',
    textAlign: 'start',
    '&:hover': {
      backgroundColor: '#007CAD',
      color: '#FFFFFF',
    },
    width: '100%',
  },
  evLogoContainer: {
    display: 'flex',
    padding: '16px 48px',
    '@media (max-width:675px)': {
      padding: '24px',
    },
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '10px',
    alignSelf: 'stretch',
  },
  logo: {
    width: '239px',
    height: 'auto',
    '@media (min-width:675px) and (max-width:1024px)': {
      display: 'flex',
      alignItems: 'center',
    },
    '@media (max-width:675px)': {
      width: '152px',
    },
  },
  formContainer: {
    display: 'flex',
    padding: '24px 48px 0px 48px',
    '@media (max-width:675px)': { padding: '24px' },
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '48px',
    alignSelf: 'stretch',
    borderTop: '1px solid #C8CDD7',
  },
  formMainContainer: {
    display: 'flex',
    width: '509px',
    padding: '24px 0px',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '24px',
    alignSelf: 'stretch',
    '@media (max-width:675px)': {
      width: '100%',
      padding: '0px',
      gap: '0px',
      flexGrow: 1,
      alignSelf: 'stretch',
    },
    position: 'relative',
    overflow: 'auto',
    background: '#FFF',
  },
  text: {
    color: '#1B202C',
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    textAlign: 'start',
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    alignItems: 'flex-start',
  },
  img: {
    width: '48px',
    height: '48px',
  },
  topContainer: {
    position: 'relative',
    minHeight: '90%',
    flex: 1,
    '@media (max-width:675px)': {
      height: 'fit-content',
      flexGrow: 1,
    },
  },
  emailText: {
    color: '#222',
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px',
  },
});
